import { twMerge } from "tailwind-merge";

import { DropdownItemProps } from "./DropdownItem";

import styles from './DropdownItem.module.css';
import Icon from "../../Icon/Icon";
import Typography from "../../Typography/Typography";

import { Variants } from '../../Typography/hooks/useTypography';

interface Props extends DropdownItemProps {
    onClick: () => void;
    label: string;
    labelStyle?: keyof typeof Variants;
    variant?: 'default'|'destructive'
}

const DropdownButtonItem = ({ onClick, className, label, labelStyle = "buttonLabel", variant = "default", icon, iconPosition = "before" }: Props) => {

    const classNames = twMerge(
        styles.DropdownItem,
        (variant === "destructive") && styles.DropdownItemDestructive,
        className
    );

    return (
        <button className={classNames} onClick={onClick}>
            {iconPosition === 'before' && icon && <Icon icon={icon} />}
            <Typography variant={labelStyle} className="grow">{label}</Typography>
            {iconPosition === 'after' && icon && <Icon icon={icon} />}
        </button>
    )

}

export default DropdownButtonItem;
